import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Mouse(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Mouse", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.4947 39h-16.421c-.7579 0-1.2632-.5053-1.2632-1.2632 0-.7579.5053-1.2631 1.2632-1.2631h16.421c3.1579 0 5.0527-1.7684 5.0527-4.8 0-1.8948-2.0211-4.0421-5.0527-4.0421h-8.8421c-.7579 0-1.2631-.5053-1.2631-1.2632 0-.7579.5052-1.2631 1.2631-1.2631h8.8421c4.5474 0 7.579 3.4105 7.579 6.5684 0 4.421-3.0316 7.3263-7.579 7.3263Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42.2842 23.7158c0-10.1052-8.3368-12.3789-14.4-11.1158-6.1895 1.2632-9.7263 3.4106-11.621 5.8106h-.5053C10.7053 18.4106 3 26.7474 3 29.0211c0 2.4 8.0842 2.4 11.7474 2.4h17.4315c5.9369-.1263 10.1053-1.6421 10.1053-7.7053Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.9474 15.1263c0-3.4105-2.5263-6.18945-5.6842-6.18945-3.0316.12632-5.5579 2.90525-5.5579 6.18945s2.5263 6.1895 5.6842 6.1895c3.0316 0 5.5579-2.779 5.5579-6.1895Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.7895 15.8842c0 2.2737-1.3895 4.0421-3.1579 4.0421-1.7684 0-3.1579-1.8947-3.1579-4.0421 0-2.1473 1.3895-4.0421 3.1579-4.0421 1.6421-.1263 3.1579 1.7684 3.1579 4.0421Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.2319 24.4739c0 1.0105-.8843 1.8948-1.8948 1.8948s-1.89472-.8843-1.89472-1.8948.88422-1.8947 1.89472-1.8947 1.8948.8842 1.8948 1.8947Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Mouse.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Mouse"
};
validateTidalLicense();
export {
  Mouse
};
//# sourceMappingURL=Mouse.js.map
